<div aria-busy="true" aria-live="polite" class="relative" role="status">
	<div aria-hidden="true">
		<div
			class="min-h-80 hero md:h-[58vw] md:max-h-200 md:min-h-112 max-md:aspect-[7/6]"
		>
			<div class="h-[640px]"></div>
		</div>
		<div class="section-spacing">
			<div class="section-inner section-gap flex flex-col">
				<div
					class="grid grid-cols-1 items-start gap-8 md:[grid-template-columns:2fr_1fr]"
				>
					<section class="space-y-6 panel">
						<div class="space-y-3">
							<div class="skel-pill w-28"></div>
							<div class="skel-title w-2/3"></div>
							<div class="grid gap-2.5">
								<div class="skel-line-lg w-full"></div>
								<div class="skel-line-lg w-11/12"></div>
								<div class="skel-line-lg w-10/12"></div>
							</div>
						</div>
						<div class="space-y-4">
							<div class="h-6 w-48 skel rounded-xl"></div>
							<div class="skel-line-lg w-64"></div>

							<div class="grid gap-3">
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-2/3"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-3/5"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-1/2"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-7/12"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-2/3"></div>
								</div>
								<div
									class="grid grid-cols-[20px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-5"></div>
									<div class="skel-line-lg w-1/2"></div>
								</div>
							</div>
						</div>
						<div class="space-y-4">
							<div class="h-6 w-44 skel rounded-xl"></div>

							<div class="flex flex-wrap gap-2">
								<div class="skel-chip w-28"></div>
								<div class="skel-chip w-32"></div>
								<div class="skel-chip w-24"></div>
							</div>

							<div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
								<div
									class="grid grid-cols-[16px_1fr] items-center gap-3"
								>
									<div class="skel-dot size-4"></div>
									<div class="skel-line w-3/4"></div>
								</div>
							</div>

							<div class="h-9 w-40 skel rounded-full"></div>
						</div>
						<div class="space-y-4">
							<div class="h-6 w-56 skel rounded-xl"></div>
							<div class="grid gap-3">
								<div
									class="grid grid-cols-[16px_1fr] items-start gap-3"
								>
									<div class="mt-1 skel-dot size-3"></div>
									<div class="skel-line w-11/12"></div>
								</div>
							</div>
						</div>
					</section>
					<aside class="space-y-5 panel">
						<div class="skel-title w-2/3"></div>
						<div class="skel-line w-40"></div>

						<div class="space-y-2">
							<div class="skel-line w-44"></div>
							<div class="skel-line w-52"></div>
						</div>

						<div class="grid grid-cols-2 gap-3">
							<div class="h-11 w-full skel rounded-lg"></div>
							<div class="h-11 w-full skel rounded-lg"></div>
						</div>

						<div class="h-10 w-full skel rounded-lg"></div>
						<div class="h-12 w-full skel rounded-xl"></div>

						<div class="grid gap-2">
							<div class="skel-line w-28"></div>
							<div class="skel-line w-56"></div>
						</div>
					</aside>
				</div>
			</div>
		</div>
	</div>
</div>
